'use client';

import { addValue } from '@dte/otw-utils-core/src/lists/addValue';
import { copyJson } from '@dte/otw-utils-core/src/objects/copyJson';
import { atom } from 'jotai';
import { workingDraftReportAtom } from './_atoms/draftReport/draftReportAtoms';
import { currentStepAtom } from './_atoms/draftReport/useCurrentStep';

/**
 * Use this to calculate what the values will be once we move beyond the current step
 */
export const workingDraftReportWithCurrentStepAtom = atom((get) => {
	const report = get(workingDraftReportAtom);
	const currentStep = get(currentStepAtom);
	// Add the current step to the answered categories
	const reportWithCurrentStep = copyJson(report);
	reportWithCurrentStep.answeredCategories = addValue(reportWithCurrentStep.answeredCategories ?? [], currentStep);
	return reportWithCurrentStep;
});
